import {
  DEAFAULT_PAGINATION_LIMIT,
  formatPaginationForService,
  getPaginationFromResponse,
  iPagination,
  iPaginationParams,
  formatFiltersForService,
  objectIsAllUndefined,
} from '../utils/helpers/lists_helpers';
import {
  ProfileOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  TableOutlined,
  ExportOutlined,
  SearchOutlined,
  ClearOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  DownOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import {
  Table,
  Button,
  Popover,
  Checkbox,
  Input,
  Space,
  Divider,
  DatePicker,
  Dropdown,
  Menu,
} from 'antd';
import _ from 'lodash';
import React, {
  FC,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from 'react';
import { ColumnsType, TableProps } from 'antd/lib/table';
import { defaultDateFormat } from '../utils/helpers/date_helpers';
//import { ExportByTableId, exportToXLSX, exportTypes } from './dataExporter';

//import PdfButton from './pdf/PdfButton';
//import JsonLog from './json_log';

//import CommonPdfTable from './pdf/CommonPdfTable';
import Loading from './Loading';
import { removeEmptyVal } from './Forms/FormHelpers';
import CommonButton from './Buttons/CommonButton';
import { TableRowSelection } from 'antd/lib/table/interface';
import Tooltip from 'antd/es/tooltip';
import { showErrorNotification } from '../services/API';

export interface CommonTableColumns extends ColumnsType<any> {
  dataIndex?: any;
}
export interface RowTableActions {
  actions?: {
    /**Label dal'lazione  */
    label: string;
    /**Funzione da applicare alle righe selezionate , se ritorna true la tabella viene refreshata al complete */
    action: (selectedRowItems: any[], selectedRowIds: any[]) => Promise<boolean | any>;
    icon?: React.ReactNode;
  }[];
}

interface CommonTableProps extends TableProps<any> {
  id?: string;
  service?: (paginationParams: iPaginationParams, filters: any) => any;
  data?: [] | any[];

  header?: any;
  history?: any;
  title?: any;
  loading?: boolean;
  columns: any[];

  debug?: boolean;
  hidePagination?: boolean;
  footer?: any;
  rowClassName?: any;
  className?: string;
  ref?: any;
  showSizeChanger?: boolean;
  pageSize?: number;

  rowKey?: string;
  /** api da chiamare per ottenere un array di array di dati già puliti per esportazione csv/xls.. */
  serviceExport?: (fieldsToSearch?: any, exportColumns?: any[]) => Promise<any>;
  enableExport?: boolean;
  /** mostra la ricerca su TUTTE le colonne */
  searchAllColumns?: boolean;
  /** mostra l'ordinamento su TUTTE le colonne,
   * diversamente dal sort:true sulle singole colonne
   */
  sortAllColumns?: boolean;
  /** Lista di colonne per l'esportazione massiva */
  exportColumns?: any[];
  showRecordCount?: boolean;
  initialFilters?: any;
  rowActions?: RowTableActions;
}

export interface CommonTableActions {
  focusOnRow: () => any;
  getNewData: (filters?: any, pagination?: iPagination) => any;
  refresh: () => any;
  resetTable: () => any;
}

const CommonTable: FC<CommonTableProps> = forwardRef((props, ref) => {
  //usePropsUpdate(props);

  const [loading, setLoading] = useState(props.loading || false);

  const [data, setData] = useState(props.data || null);

  const [forceUpdate, setForceUpdate] = useState(false);
  // const [hidePagination, setHidePagination] = useState(props.props.hidePagination || false);

  const tableRef = useRef(null);
  const activeFilters = useRef(props?.initialFilters || undefined);

  const rowKey: any = useMemo(() => props.rowKey || 'id', [props.rowKey]);

  const allAvailableKeys = useMemo(() => data?.map((e) => e[rowKey]) || [], [data, rowKey]);
  const [expandedKeys, setExpandedKeys] = useState<any>([]);

  const mergeFilters = (newFilters) => {
    const currents = removeEmptyVal(activeFilters.current);
    // const filters = removeEmptyVal(newFilters);
    //debugger;
    activeFilters.current = removeEmptyVal(_.merge(currents, newFilters));
    return activeFilters.current;
  };
  // Se ho cercato o ordinato
  const tableDirty = useRef(false);
  // const clearFiltersArray = useRef(null);

  const [Pagination, setPagination] = useState<iPagination>({
    current: 1, // current page number
    pageSize: props.pageSize || DEAFAULT_PAGINATION_LIMIT, // number of data items per page
    hideOnSinglePage: true,
    // total: 0, // total number of data items
    // pageCount: 1, // total number of pages
    // sorter: '',
  });

  /** SEARCH TABLE */
  // const [searchText, setSearchText] = useState("");
  // const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const [exporting, setExporting] = useState(false);
  const exportData = useRef(undefined);

  const tableID = useMemo(() => props.id || _.snakeCase(props.title || _.uniqueId('commonTable')), [
    props.id,
    props.title,
  ]);
  const [tableReady, setTableReady] = useState(false);

  useEffect(() => {
    if (props.loading !== undefined) {
      setLoading(props.loading);
    }

    initTable();
  }, [props.data, props.loading, props.columns]);

  const initTable = async () => {
    if (props.service) {
      await getData(Pagination);
    } else if (props.data) {
      setData(props.data);
    } else {
      console.error('NO data or service props passed to CommonTable');
    }

    tableDirty.current = false;
    // onCheckAllColumnsChange(true)
    setTimeout(() => setTableReady(true), 500);
  };

  const setColumnSearch = (column) => {
    const dataIndex = column.dataIndex || column.key;
    // TODO aggiungere nuovi tipi di filtro
    let type: 'text' | 'date' = 'text';
    if (column?.search === 'date') {
      type = 'date';
    }
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }} className="column-filter">
          {type === 'date' && (
            <DatePicker
              ref={searchInput}
              placeholder={`Cerca in ${column?.title || dataIndex}`}
              format={defaultDateFormat}
              value={selectedKeys?.[0] || undefined}
              onChange={(momentDate) => {
                setSelectedKeys([momentDate]);
              }}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
          )}
          {type === 'text' && (
            <Input
              ref={searchInput}
              placeholder={`Cerca in ${column?.title || dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex, clearFilters)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
          )}

          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex, clearFilters)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Cerca
            </Button>
            <Button
              onClick={() => resetFieldSearch(clearFilters)}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value, record) =>

        // Ricerca su dati visibili
        // const recordData = _.get(record, dataIndex);
        // const found = recordData.toString().toLowerCase().includes(value.toLowerCase());
        // return found;
        true,
      // onFilterDropdownVisibleChange: (visible) => {
      //   try {
      //     if (visible) {
      //       if (type === 'text') {
      //         setTimeout(() => searchInput?.current?.select());
      //       }
      //       setTimeout(() => searchInput?.current?.focus());
      //     }
      //   } catch (e) {
      //     console.warn(e);
      //   }
      // },
      // render: text => {
      //
      //   return searchedColumn === dataIndex ? (
      //     <Highlighter
      //       highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
      //       searchWords={[searchText]}
      //       autoEscape
      //       textToHighlight={text.toString()}
      //     />
      //   ) : (
      //       text
      //     )
      // },
    };
  };

  const columns = useMemo(() => {
    let _columns: any = [];

    if (props.columns) {
      _columns = props.columns.map((col, index) => {
        if (
          col.dataIndex &&
          (typeof col.dataIndex === 'string' || col.dataIndex instanceof String)
        ) {
          col.dataIndex = col.dataIndex.split('.');
        }
        const columnClassname: string = col?.className || '';

        let newCol = {
          ...col,
          onHeaderCell: (column) => ({
            width: column.width, // || 200,
            // onResize: handleResize(index)
          }),
        };

        // SEARCH FUNCTIONS
        if (props.searchAllColumns || col.search) {
          if (!columnClassname.includes('actions') && !columnClassname.includes('hideSearch')) {
            //debugger;
            if (!newCol.filters) {
              newCol = {
                ...newCol,
                ...setColumnSearch(col),
              };
            }
          }
        }

        // SORT FUNCTIONS
        if (props.sortAllColumns) {
          if (!columnClassname.includes('actions') && !columnClassname.includes('hideSort')) {
            newCol = {
              ...newCol,
              sorter: col.sort ?? true,
            };
          }
        }

        if (newCol.key === 'action') {
          newCol.className = `${newCol.className || ''} table-actions`;
        }

        return newCol;
      });

      if (props.debug) {
        const idColumn = {
          title: 'ID',
          width: 50,
          dataIndex: 'id',
          className: 'jsonLog  hidePdf',
        };
        _columns = [idColumn, ..._columns];
      }

      if (props.expandable) {
        const expColumn = {
          width: 50,
          title: allAvailableKeys.every((e) => expandedKeys.includes(e)) ? (
            <CommonButton
              icon={<MinusCircleOutlined />}
              onClick={() => collapseAll()}
              tooltip="Chiudi tutti dettagli"
              type="primary"
            />
          ) : (
            <CommonButton
              icon={<PlusCircleOutlined />}
              onClick={() => expandAll()}
              tooltip="Apri tutti dettagli"
              type="primary"
            />
          ),
          key: 'expand',
          render: (_, record) =>
            expandedKeys.includes(record[rowKey]) ? (
              <CommonButton
                icon={<MinusCircleOutlined />}
                tooltip="Chiudi dettagli"
                onClick={() => toggleExpandedKeys(record[rowKey])}
                type="link"
              />
            ) : (
              <CommonButton
                icon={<PlusCircleOutlined />}
                tooltip="Apri dettagli"
                onClick={() => toggleExpandedKeys(record[rowKey])}
                type="link"
              />
            ),
        };
        _columns = [expColumn, ..._columns];
      }
    }
    // setColumns(_columns)

    return _columns;
  }, [
    allAvailableKeys,
    expandedKeys,
    props.columns,
    props.debug,
    props.expandable,
    props.searchAllColumns,
    props.sortAllColumns,
    forceUpdate,
    rowKey,
  ]);
  const plainOptions = useMemo(() => columns.map((col, index) => index), [columns]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);

  const [checkedCols, setCheckedCols] = useState({
    checkedList: plainOptions,
    indeterminate: true,
    checkAll: true,
  });

  const toggleExpandedKeys = (key) => {
    setExpandedKeys((prev) => {
      const outArr = [...prev];
      if (outArr.includes(key)) {
        return outArr.filter((e) => e !== key);
      } else {
        outArr.push(key);
        return outArr;
      }
    });
  };

  const expandAll = () => {
    setExpandedKeys(allAvailableKeys);
  };

  const collapseAll = () => {
    setExpandedKeys([]);
  };

  // The component instance will be extended
  // with whatever you return from the callback passed
  // as the second argument
  useImperativeHandle(ref, () => ({
    // focusOnRow() {
    //   // tableRef.current.querySelector(".newRow textarea").focus()
    //   window.scrollTo(0, tableRef.current.offsetTop);
    //   
    // },
    getNewData(filters = activeFilters?.current, pagination: iPagination = Pagination) {
      activeFilters.current = mergeFilters(filters);
      getData(pagination, activeFilters.current);
    },
    refresh() {
      getData(Pagination);
    },
    resetTable() {
      resetTable();
    },
  }));

  const getData = async (
    pagination: iPagination = Pagination,
    filters = activeFilters?.current
  ) => {
    if (!props.service) {
      return false;
    }
    setLoading(true);

    const formattedPagination = formatPaginationForService(pagination);
    const formattedFilters = formatFiltersForService(filters);

    await props.service(formattedPagination, formattedFilters).then((ResponseData) => {
      let data = [];
      const _pagination: iPagination = getPaginationFromResponse(ResponseData);

      data = ResponseData?.data || ResponseData;

      setPagination(_pagination);
      setData(data);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  };

  const handleTableChange = (pager, filters, sorter) => {
    activeFilters.current = mergeFilters(filters);

    let changedPagination = false;
    const hasFilters = !objectIsAllUndefined(filters);
    let _pagination: iPagination = Pagination;
    // if (current === pagination.current) { return false }
    if (Pagination.current != pager.current || Pagination.pageSize != pager.pageSize) {
      _pagination = {
        ...Pagination,
        current: pager.current,
        pageSize: pager.pageSize,
      };
      changedPagination = true;
    }

    // se c'è ordinamento
    if (sorter) {
      const { field, order, columnKey } = sorter;
      //debugger;
      _pagination.sort = field || [columnKey];
      _pagination.sort_direction = order === 'ascend' ? 'ASC' : 'DESC';

      tableDirty.current = true;
    }

    if (hasFilters) {
      tableDirty.current = true;
    }

    // cambiata paginazione
    if (changedPagination) {
      setPagination(_pagination);
    }
    // cambiati i filtri ricerca
    if (hasFilters || sorter) {
      setTimeout(() => {
        getData(_pagination, activeFilters.current);
      }, 500);
    }
    // cambiato ordinamento locale
    // else if (sorter) {
    //   setLoading(true)
    //   sortData(sorter)
    // }
  };

  const localSortData = (sorter) => {
    const { field, order, columnKey } = sorter;

    const sort_direction = order === 'ascend' ? 'asc' : 'desc';
    const sortedData = _.orderBy(data, (a) => _.get(a, field), [sort_direction]);
    setData(sortedData);
    setTimeout(() => setLoading(false), 200);
  };

  const doExport = async (type: any = 'xlsx', data: 'visible' | 'all' = 'visible') => {
    setExporting(true);

    return setTimeout(async () => {
      if (data === 'visible') {
        // ExportByTableId(tableID, type).finally(() => {
        //   setExporting(false);
        // });
      } else if (data === 'all' && props.serviceExport) {
        const allData = await props.serviceExport(
          formatFiltersForService(activeFilters?.current),
          checkedCols.checkedList
        );
        // @ts-ignore
        if (type !== 'pdf') {
          exportData.current = undefined;
          // exportToXLSX(allData, props.title, type).finally(() => {
          //   setExporting(false);
          // });
        } else {
          exportData.current = allData;
          setExporting(false);
        }
      }
    }, 50);
  };

  const onChangeCheckColumns = (checkedList: number[]) => {
    // toggleColumns(checkedList)

    // setCheckedCols((prev) => ({
    //   ...prev,
    //   checkedList,
    //   indeterminate: !!checkedList.length &&  checkedList.length < props?.exportColumns?.length,
    //   checkAll: checkedList.length === props?.exportColumns?.length,
    // }));
  };

  const onCheckAllColumnsChange = (checked) => {
    const _checkedList = checked ? props.exportColumns : [];

    // toggleColumns(_checkedList)

    setCheckedCols((prev) => ({
      ...prev,
      checkedList: _checkedList,
      indeterminate: false,
      checkAll: checked,
    }));
  };

  const ExportColumns = () => (
    <Popover
      content={
        <div id="exportColumns">
          <Checkbox
            indeterminate={checkedCols.indeterminate}
            onChange={(e) => onCheckAllColumnsChange(e.target.checked)}
            checked={checkedCols.checkAll}
          >
            Seleziona / DeSeleziona tutte
          </Checkbox>
          <Divider style={{ margin: '5px 0' }} />
          <Checkbox.Group
            className="columnsSelector"
            value={checkedCols.checkedList}
            // @ts-ignore
            onChange={onChangeCheckColumns}
            options={props?.exportColumns?.map((col, index) => ({ label: col, value: col }))}
          />
        </div>
      }
      title="Seleziona colonne da esportare"
    >
      <Button icon={<TableOutlined />}>Colonne</Button>
    </Popover>
  );

  const ExportaAllData = () => (
    <Popover
      key="exportAllPopover"
      content={
        <div>
          <p>
            <Button
              loading={exporting}
              icon={<ProfileOutlined />}
              onClick={() => doExport('csv', 'all')}
            >
              CSV
            </Button>
          </p>
          <p>
            <Button
              loading={exporting}
              icon={<FileExcelOutlined />}
              onClick={() => doExport('xlsx', 'all')}
            >
              XLS
            </Button>
          </p>
          <p>
            <Button
              loading={exporting}
              icon={<FileExcelOutlined />}
              onClick={() => doExport('html', 'all')}
            >
              HTML
            </Button>
          </p>

          <p>
            <Button
              loading={exporting}
              icon={<FileTextOutlined />}
              onClick={() => doExport('txt', 'all')}
            >
              TXT
            </Button>
          </p>
          <p>
            {exportData?.current &&
              <Button
                loading={exporting}
                icon={<FileTextOutlined />}
                onClick={() => doExport('pdf', 'all')}
              >
                PDF
              </Button>
            }
          </p>
        </div>
      }
      title="Esporta tutti i dati"
    >
      <Button loading={exporting} icon={<ExportOutlined />}>
        Esporta tutti i dati
      </Button>
    </Popover>
  );

  const ExportLocalData = () => (
    <Popover
      key="exportPopover"
      content={
        <div>
          <p>
            <Button loading={exporting} icon={<ProfileOutlined />} onClick={() => doExport('csv')}>
              CSV
            </Button>
          </p>
          <p>
            <Button
              loading={exporting}
              icon={<FileExcelOutlined />}
              onClick={() => doExport('xlsx')}
            >
              XLS
            </Button>
          </p>
          <p>
            <Button loading={exporting} icon={<FileTextOutlined />} onClick={() => doExport('txt')}>
              TXT
            </Button>
          </p>
        </div>
      }
      title="Esporta dati visibili"
    >
      <Button loading={exporting} icon={<ExportOutlined />}>
        Esporta dati visibili
      </Button>
    </Popover>
  );

  const getHeader = () => (
    <Space style={{ justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      {(props.header || props.title) && (
        <div>
          <h3 className="title">{props.title || props.header}</h3>
        </div>
      )}

      {(props.rowActions || props.enableExport) && (
        <Space>
          {
            //AZIONI RIGHE SELEZIONATE
            props.rowActions && (
              <Space className="TableRowActions">
                <Dropdown
                  trigger={['click']}
                  //icon={<PlusCircleOutlined />}

                  overlay={
                    <Menu onClick={(e) => RowAction(e.key)}>
                      {props?.rowActions?.actions?.map(({ label, action, icon }, index) => (
                        <Menu.Item key={index} icon={icon || <ToolOutlined />}>
                          {label}
                        </Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <Tooltip
                    title={
                      !selectedRowKeys.length ? 'Seleziona 1 o più elementi della tabella' : ''
                    }
                  >
                    <Button disabled={!selectedRowKeys.length} loading={loading}>
                      Azioni su elementi{' '}
                      {selectedRowKeys.length > 0 && `(${selectedRowKeys.length})`}
                      <DownOutlined />
                    </Button>
                  </Tooltip>
                </Dropdown>
              </Space>
            )
          }

          {props.enableExport && (
            <Space>
              <Button icon={<ClearOutlined />} onClick={resetTable} disabled={!tableDirty?.current}>
                Resetta
              </Button>
              {props?.exportColumns && ExportColumns()}

              <Popover
                placement="left"
                content={
                  <Space>{[ExportLocalData(), props.serviceExport && ExportaAllData()]}</Space>
                }
                title="Esporta"
              >
                <Button loading={exporting} icon={<ExportOutlined />}>
                  Esporta
                </Button>
              </Popover>
            </Space>
          )}
        </Space>
      )}
    </Space>
  );

  const getHeaderFooter = () => {
    const headerFooter: any = {};
    if (props.header || props.title || props.enableExport || props.enableExport) {
      headerFooter.title = () => getHeader();
    }

    if (props.footer) {
      headerFooter.footer = () => props.footer;
    }
    return headerFooter;
  };

  const onSelectChange = (_selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(_selectedRowKeys);
  };

  /** SEARCH TABLE */

  const resetFieldSearch = (clearFilters) => {
    // resetTable();
    clearFilters();
    // setSearchText("");
  };

  const resetTable = () => {
    // _.map(clearFiltersArray.current, (filt) => filt())
    // clearFiltersArray.current = {};

    setLoading(true);
    activeFilters.current = undefined;
    // resetto search e sorter sulle colonne
    // const _columns = columns.map((col, index) => {
    //debugger;
    //   col.filteredValue = null;
    //   col.sortOrder = false;
    //   return col;
    // })
    // setColumns(_columns)

    // resetto pagination
    setPagination((pag) => ({
      ...pag,
      sort: '',
      sorter: '',
    }));

    // checco tutte le colonne
    // onCheckAllColumnsChange(true)

    // setSearchText("");

    setForceUpdate((prev) => !prev);

    setTimeout(initTable, 50);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex, clearFilters = null) => {
    //
    // const newFilters = {
    //   ...activeFilters.current,
    //   [dataIndex]: selectedKeys[0] || selectedKeys
    // }
    //
    // 

    // activeFilters.current = newFilters
    // clearFiltersArray.current = {
    //   ...clearFiltersArray.current,
    //   [dataIndex]: clearFilters
    // }

    confirm();
    // setSearchText(selectedKeys[0]);
    // setSearchedColumn(dataIndex);
  };

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
    columnWidth: 60,
    fixed: true,
    selections: [
      // Table.SELECTION_ALL,
      // Table.SELECTION_NONE,
      //Table.SELECTION_INVERT,
      {
        key: 'all',
        text: 'Seleziona tutti',
        onSelect: (changableRowKeys) => {
          setSelectedRowKeys(changableRowKeys);
        },
      },
      {
        key: 'invert',
        text: 'Inverti Selezione',
        onSelect: (changableRowKeys) => {
          setSelectedRowKeys(
            changableRowKeys.filter((key, index) => !selectedRowKeys.includes(key))
          );
        },
      },
      {
        key: 'none',
        text: 'Deseleziona tutti',
        onSelect: (changableRowKeys) => {
          setSelectedRowKeys([]);
        },
      },
    ],
  };

  const RowAction = (index: any) => {
    console.log('🚀 ~ RowAction ~ index', index);

    const selectedRowItems = data ? data.filter((row: []) => selectedRowKeys.includes(row[rowKey])) : [];
    const rowFunction = props?.rowActions?.actions?.[index]?.action;
    if (rowFunction) {
      setLoading(true);
      rowFunction(selectedRowItems, selectedRowKeys)
        .then((shouldRefresh) => {
          if (shouldRefresh) {
            getData(Pagination);
          }
        })
        .catch((err: Error) => {
          console.error('🚀 ~ RowAction ~ err', err);
          showErrorNotification(err.message, err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  if (!tableReady) return <Loading />;
  return (
    <div ref={tableRef} className="commonTableContainer">


      <Table
        // onKeyPress={toggleDebug}
        id={tableID}
        // title={getHeader}
        // footer={props.footer || undefined}

        {...getHeaderFooter()}
        bordered={true}
        onChange={handleTableChange}
        loading={loading}
        className={`${props.className} commonTable`}
        size={props.size}
        columns={columns}
        rowKey={rowKey}
        dataSource={data}
        rowSelection={props.rowActions ? rowSelection : undefined}
        pagination={props.hidePagination ? false : Pagination}
        rowClassName={props.rowClassName}
        // components={components}
        scroll={props.scroll}
        expandable={{
          ...props.expandable,
          expandedRowKeys: expandedKeys,
          expandIconColumnIndex: -1,
        }}
        footer={() =>
          props.showRecordCount && (
            <div>Record totali trovati {Pagination?.total ?? data?.length ?? 0}</div>
          )
        }
      />

    </div>
  );
});

CommonTable.defaultProps = {
  className: 'ant-table-v1',

  hidePagination: false,
  enableExport: false,
  searchAllColumns: false,
  sortAllColumns: false,
  serviceExport: undefined,
  showRecordCount: false,
  rowActions: undefined,
  scroll: { x: '100%' },
};

export default CommonTable;
